import { ca } from '@cian/analytics';

import { QuickLink } from 'shared/types/QuickLinks';

export function trackQuickLinkMoreButtonClick(): void {
  ca('eventSite', {
    action: 'click_sopr',
    category: 'seo_block_top',
    label: 'more_link',
    name: 'oldevent',
  });
}

export function trackQuickLinkClick(quickLink: QuickLink): void {
  ca('eventSite', {
    action: 'click_sopr',
    category: 'seo_block_top',
    label: quickLink.url,
    name: 'oldevent',
  });
}
